import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        bills_summary: "",
        payments_summary: "",
        properties_summary: "",
        properties_summary_dashboard: "",
        tenants_summary: "",
        visitors_summary: {},
        units_summary: {},
        bills_payments_graph: {},
        loading: false,

        rent_roll: {rows: [], totals: {}},
        income_expense: {rows: [], totals: {}},
        maintenance: {tickets_by_status: [], expenses_by_category: []},
        downloading_rent_roll: false,
        downloading_occupancy: false,
        downloading_income_expense: false,
        downloading_maintenance: false,

        property_performance: null,
        loading_property_performance: false,
        downloading_property_performance: false,
    },
    getters: {
        properties_summary: state => state.properties_summary,
        properties_summary_dashboard: state => state.properties_summary_dashboard,
        tenants_summary: state => state.tenants_summary,
        visitors_summary: state => state.visitors_summary,
        units_summary: state => state.units_summary,
        loading: state => state.loading,
        bills_summary: state => state.bills_summary,
        payments_summary: state => state.payments_summary,
        bills_payments_graph: state => state.bills_payments_graph,

        rent_roll: state => state.rent_roll,
        income_expense: state => state.income_expense,
        maintenance: state => state.maintenance,
        downloading_rent_roll: state => state.downloading_rent_roll,
        downloading_occupancy: state => state.downloading_occupancy,
        downloading_income_expense: state => state.downloading_income_expense,
        downloading_maintenance: state => state.downloading_maintenance,

        property_performance: state => state.property_performance,
        loading_property_performance: state => state.loading_property_performance,
        downloading_property_performance: state => state.downloading_property_performance,
    },
    mutations: {
        setLoading(state, val) {
            state.loading = val
        },
        setBillsSummary(state, data) {
            state.bills_summary = data;
        },
        setPropertiesSummary(state, data) {
            state.properties_summary = data;
        },
        setPropertiesSummaryDashboard(state, data) {
            state.properties_summary_dashboard = data;
        },

        setPaymentsSummary(state, data) {
            state.payments_summary = data;
        },
        setBillsPaymentsGraph(state, data) {
            state.bills_payments_graph = data;
        },

        setTenantsSummary(state, data) {
            state.tenants_summary = data;
        },
        setVisitorsSummary(state, data) {
            state.visitors_summary = data;
        },
        setUnitsSummary(state, data) {
            state.units_summary = data;
        },

        setRentRoll(state, data) {
            state.rent_roll = data;
        },
        setIncomeExpense(state, data) {
            state.income_expense = data;
        },
        setMaintenance(state, data) {
            state.maintenance = data;
        },
        setDownloadingRentRoll(state, val) {
            state.downloading_rent_roll = val;
        },
        setDownloadingOccupancy(state, val) {
            state.downloading_occupancy = val;
        },
        setDownloadingIncomeExpense(state, val) {
            state.downloading_income_expense = val;
        },
        setDownloadingMaintenance(state, val) {
            state.downloading_maintenance = val;
        },

        setPropertyPerformance(state, data) {
            state.property_performance = data;
        },
        setLoadingPropertyPerformance(state, val) {
            state.loading_property_performance = val;
        },
        setDownloadingPropertyPerformance(state, val) {
            state.downloading_property_performance = val;
        },
    },
    actions: {

        async getBillsSummary({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getBillsSummary(filters);
                commit('setBillsSummary', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getPaymentsSummary({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getPaymentsSummary(filters);
                commit('setPaymentsSummary', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getBillsPaymentsGraph({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getBillsPaymentsSummary(filters);
                commit('setBillsPaymentsGraph', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getPropertiesSummary({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getPropertiesSummary(filters);
                commit('setPropertiesSummary', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async getPropertiesSummaryDashboard({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getPropertiesSummaryDashboard(filters);
                commit('setPropertiesSummaryDashboard', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getTenantsSummary({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getTenantsSummary(filters);
                commit('setTenantsSummary', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getVisitorsSummary({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getVisitorsSummary(filters);
                commit('setVisitorsSummary', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },
        async getUnitsSummary({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getUnitsSummary(filters);
                commit('setUnitsSummary', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                ElMessage.error(e.response.data.message);
            }
        },

        async getRentRoll({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getRentRoll(filters);
                commit('setRentRoll', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                commit('deactivateLoading', 'bill/list', {root: true});
                ElMessage.error(e.response.data.message);
            }
        },
        async getIncomeExpense({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getIncomeExpense(filters);
                commit('setIncomeExpense', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                commit('deactivateLoading', 'bill/list', {root: true});
                ElMessage.error(e.response.data.message);
            }
        },
        async getMaintenance({commit}, filters) {
            try {
                commit('activateLoading', 'bill/list', {root: true});
                const response = await api.getMaintenance(filters);
                commit('setMaintenance', response);
                commit('deactivateLoading', 'bill/list', {root: true});
            } catch (e) {
                commit('deactivateLoading', 'bill/list', {root: true});
                ElMessage.error(e.response.data.message);
            }
        },

        // Export actions - mirror tickets.store.js's downloadTicketHistory /
        // tenancy.store.js's exportTpsStatement blob-download pattern
        // exactly: fetch the blob, wrap it in an object URL, click a
        // throwaway <a download> link. `format` ('pdf'|'csv') both selects
        // the file extension here and is forwarded as a query param so the
        // backend knows which file to stream.
        async exportRentRoll({commit}, {filters, format}) {
            try {
                commit('setDownloadingRentRoll', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportRentRoll({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Rent_Roll_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setDownloadingRentRoll', false);
            } catch (e) {
                commit('setDownloadingRentRoll', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },
        async exportOccupancy({commit}, {filters, format}) {
            try {
                commit('setDownloadingOccupancy', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportOccupancy({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Occupancy_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setDownloadingOccupancy', false);
            } catch (e) {
                commit('setDownloadingOccupancy', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },
        async exportIncomeExpense({commit}, {filters, format}) {
            try {
                commit('setDownloadingIncomeExpense', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportIncomeExpense({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Income_vs_Expense_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setDownloadingIncomeExpense', false);
            } catch (e) {
                commit('setDownloadingIncomeExpense', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },
        async exportMaintenance({commit}, {filters, format}) {
            try {
                commit('setDownloadingMaintenance', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportMaintenance({...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Maintenance_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setDownloadingMaintenance', false);
            } catch (e) {
                commit('setDownloadingMaintenance', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },

        async getPropertyPerformance({commit}, {propertyId, filters}) {
            try {
                commit('setLoadingPropertyPerformance', true);
                const response = await api.getPropertyPerformance(propertyId, filters);
                commit('setPropertyPerformance', response);
                commit('setLoadingPropertyPerformance', false);
            } catch (e) {
                commit('setLoadingPropertyPerformance', false);
                ElMessage.error(e.response.data.message);
            }
        },
        async exportPropertyPerformance({commit}, {propertyId, filters, format}) {
            try {
                commit('setDownloadingPropertyPerformance', true);
                let fileName = new Date().toISOString().slice(0, 10).replaceAll("-", "_") + "_" + new Date().toLocaleTimeString();
                const response = await api.exportPropertyPerformance(propertyId, {...filters, format});
                const url = window.URL.createObjectURL(new Blob([response]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Property_Performance_Report_' + fileName + '.' + format);
                document.body.appendChild(link);
                link.click();
                commit('setDownloadingPropertyPerformance', false);
            } catch (e) {
                commit('setDownloadingPropertyPerformance', false);
                if (e.response.status === 422) {
                    ElMessage.error("Whoops! You have insufficient permissions to perform this action.");
                } else {
                    ElMessage.error(e.response.data.message);
                }
            }
        },
    }
}
